import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";



export default{
    getAllGroupsForDropdown,
    getLeafCollectionOverview,
    getOperationEntitiesByGroupForDropDown
}



async function getAllGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getLeafCollectionOverview(data){

    var newModel ={

        operationEntityID: parseInt(data.operationEntityID),
        groupID: parseInt(data.groupID),
        startDate: data.startDate,
       // endDate: data.endDate
    }
    const response = await CommonPost('/api/LeafCollectionOverview/GetLeafCollectionOverviewData', null, newModel);
    return response.data;



}
